import { render, staticRenderFns } from "./DocumentNewVersionModal.vue?vue&type=template&id=05044677"
import script from "./DocumentNewVersionModal.vue?vue&type=script&lang=js"
export * from "./DocumentNewVersionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports